module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDUxMS45OHY1MTEuOTg0SDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMzZhMTAwIiBkPSJNMzQxLjMyIDBoMTcwLjY2djUxMS45ODRIMzQxLjMyek0wIDBoMTcwLjY2djUxMS45ODRIMHoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ng.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ng.svg
// module chunks = 0